/* @flow */

import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';
import AddFileModal from './AddFileModal';
import AddYoutubeModal from './AddYoutubeModal';
import AddGalleryModal from './AddGalleryModal';
import * as API from '../api';

type Props = {
  isSaving: boolean,
  onAdd: (type, content) => void,
};

type State = {
  currentModalType?: string,
  isCreatingResource: boolean,
};

const styles = {
  input: {
    display: 'none',
  },
};

class AddDocumentButton extends Component {
  props: Props;
  state: State;

  fileInput: any;

  constructor(props: Props) {
    super(props);

    this.state = {
      isCreatingResource: false,
    };
  }

  showModal = type => this.setState({ currentModalType: type });
  hideModal = () => this.setState({ currentModalType: undefined });

  addFile = resource => {
    this.props.onAdd('file', {
      name: resource.name,
      resource,
      resourceId: resource.id,
    });

    this.hideModal();
  };

  addYoutube = (name, youtubeId, message) => {
    this.props.onAdd('youtube', {
      name,
      message,
      youtubeId,
    });

    this.hideModal();
  };

  addGallery = (name, message) => {
    this.props.onAdd('gallery', {
      name,
      message,
      items: [],
    });

    this.hideModal();
  };

  addLocalFile = event => {
    if (event.target instanceof HTMLInputElement) {
      const files = event.target.files;
      if (files.length > 0) {
        this.setState({
          isCreatingResource: true,
        });

        // Uploading it then set is as selected
        API.upload(files[0]).then(resource => {
          this.setState({
            isCreatingResource: false,
          });

          this.props.onAdd('file', {
            name: resource.name,
            resource,
            resourceId: resource.id,
          });
        });
      }
    }
  };

  onAdd = type => () => this.showModal(type);

  onAddLocal = () => {
    this.fileInput.click();
  };

  render() {
    const { isSaving } = this.props;
    const { currentModalType, isCreatingResource } = this.state;

    const modal = () => {
      switch (currentModalType) {
        case 'file':
          return (
            <AddFileModal
              open={true}
              onSelected={this.addFile}
              onClose={this.hideModal}
            />
          );
        case 'youtube':
          return (
            <AddYoutubeModal
              open={true}
              onSelected={this.addYoutube}
              onClose={this.hideModal}
            />
          );
        case 'gallery':
          return (
            <AddGalleryModal
              open={true}
              onSelected={this.addGallery}
              onClose={this.hideModal}
            />
          );
        default:
          return null;
      }
    };

    return (
      <div>
        {modal()}
        <Dropdown
          text="Ajouter"
          disabled={isSaving || isCreatingResource}
          icon="add"
          floating
          labeled
          button
          className="basic icon"
        >
          <Dropdown.Menu>
            <Dropdown.Item
              icon="file outline"
              text="Fichier depuis le gestionnaire de ressources"
              onClick={this.onAdd('file')}
            />
            <Dropdown.Item
              icon="desktop"
              text="Fichier privé depuis mon ordinateur"
              onClick={this.onAddLocal}
            />
            <Dropdown.Item
              icon="photo"
              text="Galerie Photos"
              onClick={this.onAdd('gallery')}
            />
            <Dropdown.Item
              icon="youtube"
              text="Vidéo Youtube"
              onClick={this.onAdd('youtube')}
            />
          </Dropdown.Menu>
        </Dropdown>
        <input
          type="file"
          name="upload"
          onChange={this.addLocalFile}
          style={styles.input}
          ref={input => {
            this.fileInput = input;
          }}
        />
      </div>
    );
  }
}

export default AddDocumentButton;



// WEBPACK FOOTER //
// ./src/modules/my-space/components/AddDocumentButton.js